export default function Sample() {
    return (
        <div className="two">
         <div className="proof-shop">
             <div className="sample">
                <div className="left help">
                    <h1>Say hello to our new hues!</h1>
                    <p>Double the color, double the fun! Get to know the newest additions to the Clare paint color palette: Good as Gold and Meet Cute!</p>
                </div>
                    <img src="./img/splash.jpg" alt=""/>
             </div>

             <div className="sample">
                    <img className='gif' src="./img/nomess.gif" alt=""/>
                <div className="right help">
                    <h1>Sample paint colors without the mess</h1>
                    <p>Say goodbye to tiny paint chips and messy sample pots. Our Perfect Color Swatch lets you sample paint colors in an instant — just peel and stick. Bonus - our paint swatches always ship FREE!</p>
                </div>
             </div>

             <div className="sample">
                <div className="left help">
                    <h1>Zero VOC paint for a healthier home</h1>
                    <p>All of our premium interior paints are Zero VOC* and GREENGUARD Gold Certified, which means they're scientifically tested to meet the world’s most stringent standards for low chemical emissions and support healthier indoor air quality.</p>
                </div>
                    <img src="./img/family.jpg" alt=""/>
             </div>

             <div className="shop">
                 <h3>SHOP PAINT</h3>
                 <h1>The best interior paint & supplies</h1>
                 <div className="products">
                     <div className="things first">
                         <img src="./img/cane.jpg" alt=""/>
                         <p>WALL PAINT</p>
                     </div>
                     <div className="things second">
                         <img src="./img/tray.jpg" alt=""/>
                         <p>SUPPLIES</p>
                     </div>
                     <div className="things third">
                         <img src="./img/cane1.jpg" alt=""/>
                         <p>PRIMER</p>
                     </div>
                 </div>
             </div>
         </div>     

             <div className="share">
                 <p>@PAINT | #SHAREYOURPAINT</p>
                 <div className="shared">
                     <img src="./img/chair.jpg" alt=""/>
                     <img src="./img/lamp.jpg" alt=""/>
                     <img src="./img/living1.jpg" alt=""/>
                 </div>
             </div>
         </div> 
    )
}
